import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { StoryblokComponent, useStoryblokState } from 'gatsby-source-storyblok';

const FooterWrapper = () => {
  const data = useStaticQuery(graphql`
    query FooterStoryQuery {
      storyblokEntry(full_slug: { eq: "footer" }) {
        content
        full_slug
        internalId
        name
        uuid
      }
    }
  `);

  const story = useStoryblokState(data.storyblokEntry);

  return story?.content && <StoryblokComponent blok={story.content} />;
};

export default FooterWrapper;
